__turbopack_context__.v({
  "card": "skills-module-scss-module__AIoXGa__card",
  "heading": "skills-module-scss-module__AIoXGa__heading",
  "icon": "skills-module-scss-module__AIoXGa__icon",
  "icon-circle": "skills-module-scss-module__AIoXGa__icon-circle",
  "label": "skills-module-scss-module__AIoXGa__label",
  "list": "skills-module-scss-module__AIoXGa__list",
  "skill": "skills-module-scss-module__AIoXGa__skill",
  "skills": "skills-module-scss-module__AIoXGa__skills",
});
